<template>
    <time
        class="d-flex"
        :datetime="time"
    >
        {{ formatted }}
    </time>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'DateTime',
        props: {
            format: {
                type: String,
                default: 'dddd D MMMM YYYY HH:mm:ss',
            },
            time: {
                type: String,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                displayTime: null,
            };
        },
        mounted() {
            if (!this.time) {
                this.update();
                setInterval(() => { this.update(); }, 1000);
            } else {
                this.displayTime = this.time;
            }
        },
        computed: {
            formatted() {
                if (!this.displayTime) return null;
                return moment(this.displayTime).local().format(this.format);
            },
        },
        methods: {
            update() {
                this.displayTime = moment().locale('nl');
            },
        },
    };
</script>
